import {Component, Injector} from '@angular/core';
import {EntitiesListOrchestratorComponent} from "../entities-list-orchestrator/entities-list-orchestrator.component";
import {ZoneService} from "../../../../../services/zones.service";


@Component({
    selector: 'app-geozones-list-orchestrator',
    templateUrl: '../entities-list-orchestrator/entities-list-orchestrator.component.html',
    styleUrls: ['../entities-list-orchestrator/entities-list-orchestrator.component.css'],
    standalone: false
})
export class GeozonesListOrchestratorComponent extends EntitiesListOrchestratorComponent {
  public constructor(protected injector: Injector) {
    super(injector);
    this.manipulationService = injector.get(ZoneService);
    this.IsCopyControl = true;
  }
}
